import React, { Component } from 'react';
//import MetaTags from 'react-meta-tags';
//import {Helmet} from "react-helmet";

//import Fs from 'fs';
//import Gm from 'gm';
//import NameGen from './name-gen.js';
//import logo from './logo.svg';
import './App.css';
import './animate.css';

class App extends Component {

    
  constructor(props) {
    super(props);
    this.state = {isToggleOn: true};
    this.adres = "http://digitalcultures.pl/hybridizer/";
    this.adresnoh = "digitalcultures.pl%2Fhybridizer";  
    this.abrest = "../hybridizer/"; //"./"; //
       this.adresrich = `http%3A%2F%2F${this.adresnoh}%2F`;
    this.adresricmerg = `http%3A%2F%2F${this.adresnoh}%2Fmerge%2F`;  
      
    this.hybrid = ["leviathan", "warthog", "komodo", "algae eater", "lizard", "crocodile", "rabbit", "alpaca", "pony", "moose", "cow", "sheep", "herring", "snail", "ostrich", "pike", "ram", "beaver", "seal", "hippo", "chameleon", "capricorn", "lion", "walrus", "anteater", "rhino", "baboon", "shrimp", "elephant", "goat", "tiger", "snake", "camel", "unicorn", "wolf", "beetle"];  
      
    this.matter = ["winged", "coyote", "mustang", "lemur", "seashell", "armadillo", "mandrill", "egg-bearing", "three-toed", "saltwater", "deer", "squirrel", "shaggy", "otter", "zebra ", "dappled", "spotty", "dairy", "gecko", "gazehound", "jaguar", "tailless", "short-legged", "stinging", "doggy", "fledged", "meerkat", "reptile"];  
    
    this.wyjatek = 0;  
    this.intro = 1;  
      
    this.numbl= 3;
    this.numbr= 1;
      
    this.numbl_min= 2;  
    this.numbr_min= 28;
    
    this.numbl_max= 4;  
    this.numbr_max= 2;   
      
    this.scale= 0;
    
    //this.clock= 0;  
    
    this.bgAudio = new Audio(`${this.adres}righty/bg-sound.ogg`);
    this.lottoAudio = new Audio(`${this.adres}righty/lotto-sound.ogg`);
    this.modeAudio = new Audio(`${this.adres}righty/mode-click.ogg`);
    this.upAudio = new Audio(`${this.adres}righty/arrow-up-click.ogg`);
    this.dwnAudio = new Audio(`${this.adres}righty/arrow-down-click.ogg`);
     
    this.embed = '';  
    this.richembed = '';
    this.merge = '';
      
    this.state = {
            
            //wyjatek: 0,
            embedinfo: 'embedinfo',    
        
            create: 'block',
            share: 'none',
            dwnld: 'none',
            about: 'none',
            
            btncreate: 'active',
            btnshare: '',
            btndwnld: '',
            btnabout: '',
        
            clock: 'none',
            inclock: 'none',
            
            wysokosc: `${window.innerHeight}`,
            
            iteracje: '0',
            dezaktywcisk: '0',
            nohybryd: '0',
            offaudio: '0',
            
            //akoteriaktiv: "animated fadeOut",
            //bkoteriaktiv: "animated fadeOut",
            
            //amateriaktiv: "animated fadeOut",
            //bmateriaktiv: "animated fadeOut",
            
            asrodaktiv: "animated fadeIn",
            bsrodaktiv: "animated fadeIn",

            wanimaktiv: "animated fadeIn",
            animaktiv: "off", //animated slideInDown",
            banimaktiv: "off", //"animated slideInUp",
    
            urlap: "", //`${this.adres}lefty/720/${this.numbl_min}.gif`,   
            urla: `${this.adres}lefty/720/${this.numbl}.gif`,
            urladown: "", //`${this.adres}lefty/720/${this.numbl_max}.gif`,
            
            urlbup: "", //`${this.adres}righty/720/${this.numbr_min}.gif`,  
            urlb: `${this.adres}righty/720/${this.numbr}.gif`,
            urlbown: "", //`${this.adres}righty/720/${this.numbr_max}.gif`
            
            }
     
    this.urla = `${this.adres}lefty/720/${this.numbl}.gif`;
    this.urlb = `${this.adres}righty/720/${this.numbr}.gif`;  
    
    // This binding is necessary to make `this` work in the callback
    this.handleClick = this.handleClick.bind(this);
    this.iterazionEnd = this.iterazionEnd.bind(this);
    this.sayMyName = this.sayMyName.bind(this);
    //this.losuj = this.losuj.bind(this);  
      this.losuj_one = this.losuj_one.bind(this);
    //this.losuj_two = this.losuj_two.bind(this);
    this.aktualizuj = this.aktualizuj.bind(this);
    this.cisk = this.cisk.bind(this);  
  }


    
    
    aktualizuj(columnline, direction, max_nr) {
            
            //console.log(columnline);    
        
            columnline = columnline + direction;
            if (columnline < 1) columnline = max_nr; //=4;
            if (columnline > max_nr) columnline = 1;  //> 4)
            
            return columnline;
    }

    cisk(polowa) {

            console.log(polowa);
                
            let kierun = 1;

            if (polowa === "a1" || polowa === "b1") kierun=1;
            if (polowa === "a2" || polowa === "b2") kierun=-1;

            //console.log($("button.up.a").attr("class"));
            
            if (polowa === "a1" || polowa === "a2") {
                        if (kierun === 1) {
                            
                        this.numbl_min = this.numbl;
                        this.numbl = this.numbl_max;    
                        this.numbl_max = this.aktualizuj(this.numbl_max, kierun, 36);
                            
                        } else {
                        
                        this.numbl_max = this.numbl;    
                        this.numbl = this.numbl_min;                    
                        this.numbl_min = this.aktualizuj(this.numbl_min, kierun, 36);
                            
                        }

            }

            if (polowa === "b1" || polowa === "b2") {
                        if (kierun === 1)  {           
                        
                        this.numbr_min = this.numbr;
                        this.numbr = this.numbr_max;    
                        this.numbr_max = this.aktualizuj(this.numbr_max, kierun, 28);  
                            
                        } else {
                        
                        this.numbr_max = this.numbr;    
                        this.numbr = this.numbr_min;
                        this.numbr_min = this.aktualizuj(this.numbr_min, kierun, 28);
                            
                        }

            }

    }


    getRandomInt = max => Math.floor(Math.random() * Math.floor(max) + 1);

    losuj_one() {
        
            let lastime = this.numbl_max;
            while (this.numbl_max === lastime) this.numbl_max = this.getRandomInt(36);            
            
            //let cheat = this.numbl;  //cheat
            this.numbl = this.numbl_max;
            this.numbl = this.aktualizuj(this.numbl, -1, 36);
        
            this.numbl_min = this.numbl;
            this.numbl_min = this.aktualizuj(this.numbl_min, -1, 36);
            
            //this.numbl_max = this.numbl; //tego nie bylo 
        
            //this.numbl_min = cheat; //cheat
        
        

            lastime = this.numbr_max;
            while (this.numbr_max === lastime) this.numbr_max = this.getRandomInt(28);        
            
            //cheat = this.numbr; //cheat
            this.numbr = this.numbr_max;
            this.numbr = this.aktualizuj(this.numbr, -1, 28);
            
            this.numbr_min = this.numbr; //tego nie bylo ????
            this.numbr_min = this.aktualizuj(this.numbr_min, -1, 28); //a to bylo !!!
            
            //this.numbr_max = cheat; //cheat
        
            
        //console.log(`${this.adres}lefty/720/${this.numbl}.gif`);


    }

    sayMyName() {
        
        if (this.numbl === 10 && this.numbr === 12) this.wyjatek = "moosquirrel";
          else
        if (this.numbl === 6 && this.numbr === 12) this.wyjatek = "crocosquirrel";
          else
        if (this.numbl === 20 && this.numbr === 12) this.wyjatek = "hipposquirrel";
          else
        if (this.numbl === 26 && this.numbr === 12) this.wyjatek = "rhinosquirrel";
          else
        if (this.numbl === 6 && this.numbr === 2) this.wyjatek = "crocoyote";
          else
        if (this.numbl === 20 && this.numbr === 2) this.wyjatek = "hippoyote";
          else
        if (this.numbl === 27 && this.numbr === 27) this.wyjatek = "baboomeerkat";
          else
        if (this.numbl === 10 && this.numbr === 3) this.wyjatek = "moosetang";
          else
        if (this.numbl === 26 && this.numbr === 4) this.wyjatek = "lemurhino";
          else
        if (this.numbl === 6 && this.numbr === 6) this.wyjatek = "crocadillo";
          else
        if (this.numbl === 3 && this.numbr === 11) this.wyjatek = "komodeer";
          else
        if (this.numbl === 6 && this.numbr === 11) this.wyjatek = "crocodeer";
          else
        if (this.numbl === 2 && this.numbr === 15) this.wyjatek = "zebrahog";
          else
        if (this.numbl === 10 && this.numbr === 15) this.wyjatek = "moosebra";
          else
        if (this.numbl === 8 && this.numbr === 15) this.wyjatek = "zebralpaca";
          else
        if (this.numbl === 29 && this.numbr === 15) this.wyjatek = "zebrelephant";
          else
        if (this.numbl === 26 && this.numbr === 15) this.wyjatek = "zebrhino";
          else
        if (this.numbl === 17 && this.numbr === 15) this.wyjatek = "zebram";
          else
        if (this.numbl === 31 && this.numbr === 15) this.wyjatek = "zebriger";
          else
        if (this.numbl === 17 && this.numbr === 27) this.wyjatek = "rameerkat";
          else
        if (this.numbl === 29 && this.numbr === 27) this.wyjatek = "meerkelephant";
          else
        if (this.numbl === 33 && this.numbr === 27) this.wyjatek = "meercamel";
          else
        if (this.numbl === 6 && this.numbr === 19) this.wyjatek = "geckodile";
          else
        if (this.numbl === 22 && this.numbr === 19) this.wyjatek = "geckopricorn";
          else
        if (this.numbl === 29 && this.numbr === 19) this.wyjatek = "geckolephant";
          else
        if (this.numbl === 6 && this.numbr === 21) this.wyjatek = "crocoguar";
          else
        if (this.numbl === 20 && this.numbr === 21) this.wyjatek = "hippoguar";
          else
        if (this.numbl === 31 && this.numbr === 21) this.wyjatek = "tiguar";
          else
        if (this.numbl === 6 && this.numbr === 14) this.wyjatek = "crocotter";
          else
        if (this.numbl === 11 && this.numbr === 2) this.wyjatek = "mooyote";
          else
        if (this.numbl === 11 && this.numbr === 14) this.wyjatek = "mootter";
          else
        if (this.numbl === 30 && this.numbr === 24) this.wyjatek = "stingoat";
          else
        if (this.numbl === 14 && this.numbr === 3) this.wyjatek = "horsnail";
          else
        if (this.numbl === 19 && this.numbr === 3) this.wyjatek = "horseal";
          else
        if (this.numbl === 6 && this.numbr === 25) this.wyjatek = "crocodoggy";
          else
        if (this.numbl === 27 && this.numbr === 15) this.wyjatek = "baboonebra";
          else
        if (this.numbl === 3 && this.numbr === 25) this.wyjatek = "komodoggy";
          else
        if (this.numbl === 31 && this.numbr === 28) this.wyjatek = "reptilger";
          else
        if (this.numbl === 23 && this.numbr === 28) this.wyjatek = "reptilion";
          else
        if (this.numbl === 23 && this.numbr === 15) this.wyjatek = "zeblion";
          else
        if (this.numbl === 8 && this.numbr === 28) this.wyjatek = "alpacasaur";
          else
        if (this.numbl === 20 && this.numbr === 28) this.wyjatek = "hipposaur";
          else
        if (this.numbl === 26 && this.numbr === 28) this.wyjatek = "rhinosaur";
          else
        if (this.numbl === 13 && this.numbr === 10) this.wyjatek = "herringwhale";
          else
        if (this.numbl === 11 && this.numbr === 18) this.wyjatek = "a cow";
          else
        if (this.numbl === 28 && this.numbr === 10) this.wyjatek = "shrimpwhale";
          else
        if (this.numbl === 5 && this.numbr === 19) this.wyjatek = "crossbreed lizard";
          else
        if (this.numbl === 5 && this.numbr === 28) this.wyjatek = "crossbreed reptile";
          else
        if (this.numbl === 8 && this.numbr === 18) this.wyjatek = "wagging alpaca";
          else
        if (this.numbl === 30 && this.numbr === 18) this.wyjatek = "wagging goat";
          else
        if (this.numbl === 33 && this.numbr === 18) this.wyjatek = "wagging camel";
          else
        if (this.numbl === 3 && this.numbr === 28) this.wyjatek = "reptilemodo";
          else
        if (this.numbl === 6 && this.numbr === 28) this.wyjatek = "reptiledile";
          else
        if (this.numbl === 21 && this.numbr === 28) this.wyjatek = "reptimeleon";
          else
        if (this.numbl === 32 && this.numbr === 28) this.wyjatek = "two-legged snake";
          else
        if (this.numbl === 15 && this.numbr === 26) this.wyjatek = "crossbreed ostrich";
          else
        if (this.numbl === 3 && this.numbr === 19) this.wyjatek = "geckomodo";
          else
        if (this.numbl === 12 && this.numbr === 18) this.wyjatek = "wagging sheep";
          else
        if (this.numbl === 7 && this.numbr === 15) this.wyjatek = "zebrabbit";
          else
        if (this.numbl === 8 && this.numbr === 13) this.wyjatek = "long alpaca";
          else
        if (this.numbl === 4 && this.numbr === 10) this.wyjatek = "alg eater whale";
          else
        if (this.numbl === 1 && this.numbr === 10) this.wyjatek = "monstrous leviathan";
          else
        if (this.numbl === 32 && this.numbr === 10) this.wyjatek = "snake whale";
          else
        if (this.numbl === 24 && this.numbr === 10) this.wyjatek = "walrus whale";
          else
        if (this.numbl === 19 && this.numbr === 10) this.wyjatek = "seal whale";
          else
        if (this.numbl === 16 && this.numbr === 10) this.wyjatek = "pike whale";
          else
        if (this.numbl === 14 && this.numbr === 10) this.wyjatek = "snail whale";
          else
        if (this.numbl === 15 && this.numbr === 8) this.wyjatek = "egg-bearing crossbreed ostrich";
          else
        if (this.numbl === 14 && this.numbr === 5) this.wyjatek = "crossbreed snail";
          else
        if (this.numbl === 6 && this.numbr === 4) this.wyjatek = "crocolemur";
          else
        if (this.numbl === 5 && this.numbr === 4) this.wyjatek = "lemur lizard";
          else
        if (this.numbl === 15 && this.numbr === 1) this.wyjatek = "flying ostrich";
          else
        if (this.numbl === 17 && this.numbr === 4) this.wyjatek = "lemuram";
          else
        if (this.numbl === 21 && this.numbr === 4) this.wyjatek = "chamelemur";
          else
        if (this.numbl === 29 && this.numbr === 4) this.wyjatek = "lemurephant";
          else
        if (this.numbl === 34 && this.numbr === 4) this.wyjatek = "lemunicorn";
          else
        if (this.numbl === 5 && this.numbr === 11) this.wyjatek = "lizardeer";
          else      
        this.wyjatek = this.matter[this.numbr-1] + " " + this.hybrid[this.numbl-1];
        
        this.embed = `<iframe width="720" height="720" src="${this.adres}merge/hybrid${this.numbl}matter${this.numbr}.gif" style="border:none;" ></iframe>`;
  
        this.richembed = `https://www.tumblr.com/widgets/share/tool?posttype=video&tags=digitalcultures%2C%20hybridizer&title=%23digitalcultures&content=%3Ciframe%20width%3D%22720%22%20height%3D%22720%22%20src%3D%22http%3A%2F%2Fdreamgrit.pl%2Fmerge%2Fmp4%2Fhybrid11matter11.mp4%22%20style%3D%22border%3Anone%3B%22%20%3E%20%3C%2Fiframe%3E&canonicalUrl=http%3A%2F%2Fdreamgrit.pl%2Fhybridizer%2Findex.html&shareSource=tumblr_share_button`;
        
        let temp = `https://www.tumblr.com/widgets/share/tool?posttype=video&tags=digitalcultures%2C%20hybridizer&title=%23digitalcultures&content=%3Ciframe%20width%3D%22720%22%20height%3D%22720%22%20src%3D%22${this.adresrich}mp4%2Fhybrid${this.numbl}matter${this.numbr}.mp4%22%20style%3D%22border%3Anone%3B%22%20%3E%20%3C%2Fiframe%3E&canonicalUrl=http%3A%2F%2Fdreamgrit.pl%2Fhybridizer%2Findex.html&shareSource=tumblr_share_button`;
        
        temp = `https://www.tumblr.com/widgets/share/tool?posttype=video&tags=digitalcultures%2C%20hybridizer&title=%23digitalcultures&content=%3Ciframe%20width%3D%22720%22%20height%3D%22720%22%20src%3D%22${this.adresrich}hybrid${this.numbl}matter${this.numbl}.gif%22%20style%3D%22border%3Anone%3B%22%20%3E%3C%2Fiframe%3E&canonicalUrl=http%3A%2F%2Fdreamgrit.pl%2Fhybridizer%2Findex.html&shareSource=tumblr_share_button`;
        
                //temp = `https://www.tumblr.com/widgets/share/tool?posttype=video&tags=digitalcultures%2C%20hybridizer&title=%23digitalcultures&content=${this.adresrich}hybrid${this.numbl}matter${this.numbl}.gif&canonicalUrl=http%3A%2F%2Fdreamgrit.pl%2Fhybridizer%2Findex.html&shareSource=tumblr_share_button`;
        
        //temp = `https://www.tumblr.com/widgets/share/tool?posttype=video&tags=digitalcultures%2C%20hybridizer&title=%23digitalcultures&content=%3Cembed%20src%3D%22${this.adresrich}hybrid${this.numbl}matter${this.numbl}.gif%22%20%3E%3C%2Fembed%3E&canonicalUrl=http%3A%2F%2Fdreamgrit.pl%2Fhybridizer%2Findex.html&shareSource=tumblr_share_button`;
        
                temp = `https://www.tumblr.com/widgets/share/tool?posttype=video&tags=digitalcultures%2C%20hybridizer&title=%23digitalcultures&content=%3Ciframe%20width%3D%22480%22%20height%3D%22480%22%20src%3D%22${this.adresricmerg}hybrid${this.numbl}matter${this.numbl}.gif%22%20style%3D%22border%3Anone%3B%22%20%3E%3C%2Fiframe%3E&canonicalUrl=${this.adresrich}hybridizer%2Findex.html&shareSource=tumblr_share_button`;
        
        this.richembed = temp;     
        
        console.log(`${this.richembed}`);        
                
        this.merge = `${this.adres}merge/hybrid${this.numbl}matter${this.numbr}.gif`
    }

    handleClick(zmiana) { 
        
        
        if ( zmiana === "audiom") {
        
                    if ( this.state.offaudio === "0") {   

                        this.setState({ offaudio: "active"});
                        
                        this.bgAudio.pause();
                        //this.bgAudio = new Audio();
                        this.bgAudio.loop = false;
                        this.bgAudio.muted = true;
                        //this.lottoAudio.pause();
                        //this.lottoAudio.muted = true; 
                        //this.modeAudio.muted = true; 
                        //this.upAudio.muted = true; 
                        //this.dwnAudio.muted = true;

                    } else {

                        this.setState({ offaudio: "0"});

                        //this.bgAudio = new Audio(`${this.adres}righty/bg-sound.mp3`);
                        this.bgAudio.muted = false;
                        this.bgAudio.play(); 
                        this.bgAudio.loop = true;
                        //this.lottoAudio.muted = false; 
                        //this.modeAudio.muted = false; 
                        //this.upAudio.muted = false; 
                        //this.dwnAudio.muted = false;

                    }
        
        } else {
        
        //if ( this.state.offaudio === "0") {} else 
            //this.bgAudio.muted = false;
            this.bgAudio.play();    
            
        if ( zmiana === "tmb" ) {
            
              //this.embed = `<iframe width="720" height="720" src="${this.adres}merge/mp4/hybrid${this.numbl}matter${this.numbr}.mp4" style="border:none;" ></iframe>`;
              
              document.execCommand("copy");
            
        
        } else
            
        if ( zmiana === "emb" ) {

              //this.embed = `<iframe width="720" height="720" src="${this.adres}merge/hybrid${this.numbl}matter${this.numbr}.gif" style="border:none;" ></iframe>`;
              this.setState({ embedinfo: "animated fadeOut" });     
            
              document.execCommand("copy");

        
        } else      
        
        if ( zmiana === "fb" ) {   
        
        } else 
            
        if (zmiana === "twt" || zmiana === "gift" || zmiana === "mpfor" ) {} else {
            
        //this.setState({iteracje: 0});
        
        //this.setState({wanimaktiv: "off"});
        //this.setState({materiaktiv: "off"});


        //console.log(`${this.state.iteracje}`);         
        
        
        //console.log(zmiana);  
        if (zmiana === "los")  { this.lottoAudio.currentTime = 0; this.lottoAudio.play(); } //this.losuj_one();  //this.cisk("a2"); //
            else this.cisk(zmiana);

        //this.cisk(strona);  
        this.setState(prevState => ({
            
          iteracje: 0,

          isToggleOn: !prevState.isToggleOn,

          //urla: `${this.adres}lefty/720/${this.numbl}.gif`,    
          //urlb: `${this.adres}righty/720/${this.numbr}.gif`,

          urlap: `${this.adres}lefty/720/${this.numbl_min}.gif`,    
          urlbup: `${this.adres}righty/720/${this.numbr_min}.gif`,

          urladown: `${this.adres}lefty/720/${this.numbl_max}.gif`,    
          urlbown: `${this.adres}righty/720/${this.numbr_max}.gif`         

        }));
        
        this.urla = `${this.adres}lefty/720/${this.numbl}.gif`;
        this.urlb = `${this.adres}righty/720/${this.numbr}.gif`;
        
        this.sayMyName();
              
        
        if ( zmiana === "a1" ) {this.setState({animaktiv: "animated slideInUp",
                                              asrodaktiv: "animated fadeIn",
                                              amateriaktiv: "animated fadeOut",
                                              //koteriaktiv: "animated fadeIn"
                                             });
                                this.upAudio.play(); }
        
        if ( zmiana === "a2" ) {this.setState({animaktiv: "animated slideInDown",
                                              asrodaktiv: "animated fadeIn",
                                              //materiaktiv: "animated fadeIn",
                                              akoteriaktiv: "animated fadeOut"
                                             });
                                this.dwnAudio.play(); }

        if ( zmiana === "b1") {this.setState({banimaktiv: "animated slideInUp",
                                              bsrodaktiv: "animated fadeIn",
                                              bmateriaktiv: "animated fadeOut",
                                              //koteriaktiv: "animated fadeIn"
                                            });
                                this.upAudio.play(); }
        
        if ( zmiana === "b2") {this.setState({banimaktiv: "animated slideInDown",
                                              bsrodaktiv: "animated fadeIn",
                                              //materiaktiv: "animated fadeIn",
                                              bkoteriaktiv: "animated fadeOut"
                                            });
                                this.dwnAudio.play(); }
        
        
                if (zmiana === "los") {


                    this.setState({iteracje: 1});
                    //console.log(`${this.state.iteracje}`);

                    //this.cisk("a1");
                    //this.cisk("b2");

            //        this.setState({animaktiv: "animated slideInUp"});
            //        this.setState({banimaktiv: "animated slideInDown"});
                    this.setState({animaktiv: "animated fadeOut"});
                    this.setState({banimaktiv: "animated fadeOut"});

                    //console.log(`${this.state.iteracje}`);
                    
                    //this.losuj_one();
                }    


       this.setState({wanimaktiv: "animated fadeIn",
                      materiaktiv: "animated fadeOut", 
                      dezaktywcisk: 1,
                      embedinfo: "embedinfo"});  
      
       //console.log(`${this.state.iteracje}`);
  }}}

  iterazionEnd(hanba) {

    
    if (hanba === "a2") { 
      
        
            if (this.state.iteracje === 2) { //=== 2) {
                
                //this.losuj_one();                
                
                console.log("iterazione-1 a2");
                console.log(`${this.state.iteracje}`);
                
                //this.setState({animaktiv: "animated slideInDown"});
                //this.setState({banimaktiv: "animated slideInUp"});

                this.setState({iteracje: 0});
                //this.cisk("a2");
                
                //this.numbl = this.aktualizuj(this.numbl_max, -1, 36); //=5
                //this.setState({urla: `${this.adres}lefty/720/${this.numbl}.gif`});
                //this.numbr = this.aktualizuj(this.numbr_min, 1, 28);
                //this.setState({urlb: `${this.adres}righty/720/${this.numbr}.gif`});
                
                
            }
        
            if (this.state.iteracje === 1) { // === 1) {

                this.losuj_one();
                this.sayMyName();
                
                //this.cisk("b2");    
                //this.losuj_one();
        
                this.setState({nohybryd: "", clock: "none"});  //
                
                this.urla = `${this.adres}lefty/720/${this.numbl}.gif`;
                console.log(`urla-out: ${this.urla}`);
                this.urlb = `${this.adres}righty/720/${this.numbr}.gif`;
                console.log(`urlb-out: ${this.urlb}`);

                

     //var imgpro = document.getElementsByClassName("righty")[0];
     //imgpro.style.opacity = 0;
     //imgpro.style.width = '900px';            
 //    imgpro.style.animationDelay = '2s';
  //    imgpro.style.webkitAnimationDelay = '2s';
    //    imgpro.style.mozAnimationDelay = '2s';        
     //imgpro.onload = () => {  
        

        setTimeout(function(){          
          this.setState({animaktiv: "animated fadeIn"}); /////////// this.setState({animaktiv: "animated slideInUp"});
          this.setState({banimaktiv: "animated fadeIn"}); //this.setState({banimaktiv: "animated slideInDown"});
        this.setState({nohybryd: "0"});
        }.bind(this), 200);
         
        setTimeout(function(){
        this.setState({ clock: "block" });    
        }.bind(this), 500);
                
     //}; 
                
                
                console.log("iterazione-2 a2");
                console.log(`${this.state.iteracje}`);
                
                this.setState({iteracje: 2}); //2});        
                

            }
    
    }
        
    if (hanba === "buuu1") { 
          
            if (this.state.iteracje === 2) { //=== 2) {      
                
                this.urlb = `${this.adres}righty/720/${this.numbr}.gif`;
                console.log(`urlb-out: ${this.urlb}`);
                
                console.log("iterazione-1 b1");
                console.log(`${this.state.iteracje}`);
                
                //this.setState({animaktiv: "animated slideInUp"});
                ////////////this.setState({banimaktiv: "animated slideInUp"});

                this.setState({iteracje: 0}); //0});
            }
        
            if (this.state.iteracje === 1) {
                
                this.losuj_one();
                
                //this.cisk("b2");

                console.log("iterazione-2 b1");
                console.log(`${this.state.iteracje}`);

                this.setState({animaktiv: "animated fadeIn"}); //this.setState({animaktiv: "animated slideInUp"});
                this.setState({banimaktiv: "animated fadeIn"}); ///////////this.setState({banimaktiv: "animated slideInDown"});

                this.setState({iteracje: 2});      


            }
    
    }        
      
  }

 componentWillMount() {   
     
         if (this.state.offaudio === "0" && this.bgAudio.muted === false) {
            //this.bgAudio.loop = true;
            //this.bgAudio.play();
         }         
     
    this.losuj_one();
     
        this.setState(prevState => ({
            
          iteracje: '0',
          dezaktywcisk: '0', //zmienione, bylo '0'

          isToggleOn: !prevState.isToggleOn,

          //urla: `${this.adres}lefty/720/${this.numbl+this.intro}.gif`,    
          //urlb: `${this.adres}righty/720/${this.numbr-this.intro}.gif`,

          //urlap: `${this.adres}lefty/720/${this.numbl_min}.gif`,    
          //urlbup: `${this.adres}righty/720/${this.numbr_min}.gif`,

          //urladown: `${this.adres}lefty/720/${this.numbl_max}.gif`,    
          //urlbown: `${this.adres}righty/720/${this.numbr_max}.gif`         

            
        }));
      
   console.log(`intro: ${this.intro}`); 
   
   //this.intro = 0;  //dodane, wywala intro     
     
   this.urla = `${this.adres}lefty/720/${this.numbl + this.intro}.gif`;
   this.urlb = `${this.adres}righty/720/${this.numbr - this.intro}.gif`; 
   
   //console.log(`urlawill: ${this.urla}`);     
     
   this.sayMyName();
   
   this.intro = 0; 
     
   //console.log(`urlawill: ${this.urla}`);
 }

 componentDidMount() {       
     
        if (this.state.offaudio === "0" && this.bgAudio.muted === false) {
            this.bgAudio.loop = true;
            this.bgAudio.play();
         }  
     
     //this.urla = `${this.adres}lefty/720/${this.numbl}.gif`;
     //this.urlb = `${this.adres}righty/720/${this.numbr}.gif`;
     //console.log(`urla-out: ${this.urla}`); 
     
     var hasTouch;
     var orientation = window.screen.msOrientation || (window.screen.orientation || window.screen.mozOrientation || {}).type;
     var img12 = document.getElementById("imgframe");
     
     img12.onload = () => {          

         
            this.setState(prevState => ({

          isToggleOn: !prevState.isToggleOn,

          //urla: `${this.adres}lefty/720/${this.numbl+this.intro}.gif`,    
          //urlb: `${this.adres}righty/720/${this.numbr-this.intro}.gif`,

          urlap: `${this.adres}lefty/720/${this.numbl_min}.gif`,    
          urlbup: `${this.adres}righty/720/${this.numbr_min}.gif`,

          urladown: `${this.adres}lefty/720/${this.numbl_max}.gif`,    
          urlbown: `${this.adres}righty/720/${this.numbr_max}.gif`         

            
        }));        
         
    setTimeout(function(){     
         
         console.log("image loaded correctly");  
      
      this.urla = `${this.adres}lefty/720/${this.numbl + this.intro}.gif`;
      this.urlb = `${this.adres}righty/720/${this.numbr -  this.intro}.gif`;
      console.log(`urla(): ${this.urla}`);      
         
         ///////////////////////////////
         
        this.setState(prevState => ({
            
          iteracje: '0',
          dezaktywcisk: '0',    //zmienione

          isToggleOn: !prevState.isToggleOn,         
          
          urla: `${this.adres}lefty/720/${this.numbl}.gif`,    
          urlb: `${this.adres}righty/720/${this.numbr}.gif`,

          urlap: `${this.adres}lefty/720/${this.numbl_min}.gif`,    
          urlbup: `${this.adres}righty/720/${this.numbr_min}.gif`,

          urladown: `${this.adres}lefty/720/${this.numbl_max}.gif`,    
          urlbown: `${this.adres}righty/720/${this.numbr_max}.gif`,     
            
          animaktiv: "animated slideInDown", 
          banimaktiv: "animated slideInUp",
            
          wanimaktiv: "animated fadeIn",
            
          clock: 'block',
          inclock: 'inline-block'    
        }));
       
         
     //this.setState({animaktiv: "animated slideInDown", banimaktiv: "animated slideInUp" });
     
     //this.clock= 1;           
		  
     
        }.bind(this), 1000); 
        
         
      window.addEventListener('touchstart', function setHasTouch () {
			hasTouch = true;
			// Remove event listener once fired, otherwise it'll kill scrolling performance
			window.removeEventListener('touchstart', setHasTouch);
		}, false); 
         
         
 console.log(`wysokosc: ${this.state.wysokosc}`);

  var scaleheight, scalewidth;

  scaleheight = document.body.clientHeight;
  scalewidth = document.body.clientWidth;

  this.scale = Math.min(
    scalewidth / elWidth,    
    scaleheight / elHeight
    //, 3/5  
  );
         
//|| orientation === "portrait-secondary" || orientation === "portrait-primary" || orientation === "landscape-secondary" || orientation === "landscape-primary"         
//if (scalewidth < 1024)         
if (hasTouch === true || (scalewidth < 1024 ) ) { //&& scaleheight > 700
$el.style.webkitTransform = "scale(" + 9*this.scale/10 + ", " + 9*this.scale/10 + ")";
$el.style.transform = "scale(" + 9*this.scale/10 + ")";
this.setState({ wysokosc: window.innerHeight / this.scale }); //780
} else
if (window.innerHeight < 800) { //|| hasTouch === true) {

  //console.log(`inner: ${window.innerHeight}`);
  //console.log(`body: ${document.body.clientHeight}`);
  
  $el.style.webkitTransform = "scale(" + 4*this.scale/5 + ", " + 4*this.scale/5 + ")";  
  $el.style.transform = "scale(" + 4*this.scale/5 + ")";
  this.setState({ wysokosc: Math.min( window.innerHeight / this.scale , 820 ) }); //780
}

console.log(`wysokosc: ${this.state.wysokosc}`);       
         
         
         
     setTimeout(function(){  
         

     
             }.bind(this), 3500); 
     };
     
     
 
     
     this.setState({ dezaktywcisk: 0 });
     

		
		var $el = document.getElementsByClassName("my-specific-design")[0];
		
        //var elHeight = $el.offsetHeight;
		//var elWidth = $el.offsetWidth;
        var elHeight = $el.clientHeight;
		var elWidth = $el.clientWidth;
     
     
     	
     
     window.addEventListener('resize', () => {
  
		  var scaleheight, scalewidth;
		  
		  scaleheight = document.body.clientHeight;
		  scalewidth = document.body.clientWidth;
		  
		  this.scale = Math.min(
			scalewidth / elWidth,    
			scaleheight / elHeight
            //, 3/5  
		  );
		  
        // console.log(`scale: ${this.scale}`);
         
                     //if (hasTouch === true)
                     //$el.style.transform = "scale(" + 3*this.scale/5 + ")";
                     //else         
                     //$el.style.transform = "scale(" + 3*this.scale/5 + ")";
         
         //if (window.innerHeight < 740) {
         
         //if (scalewidth < 1024)   
         if (hasTouch === true) {
         $el.style.webkitTransform = "scale(" + 9*this.scale/10 + ", " + 9*this.scale/10 + ")";             
         $el.style.transform = "scale(" + 9*this.scale/10 + ")";
         this.setState({ wysokosc: window.innerHeight / this.scale });
         } else {
             // if (window.innerHeight < 800) { 
             // $el.style.webkitTransform = "scale(" + 4*this.scale/5 + ", " + 4*this.scale/5 + ")";
             // $el.style.transform = "scale(" + 4*this.scale/5 + ")";
             // this.setState({ wysokosc: Math.min( window.innerHeight / this.scale , 820 ) }); 
         }
          //780
         
         //} else {
             
         //this.setState({ wysokosc: window.innerHeight });    
             
         //}     
             
		  //$el.css({
		//	transform: "translate(-50%, -50%) " + "scale(" + scale + ")"
		  //});
		  
		});
		
     //console.log(`<iframe width="720" height="720" src="${this.adres}merge/mp4/hybrid${this.numbl}matter${this.numbr}.mp4" style="border:none;"></iframe>`)
     
     
}

 componentDidUpdate(prevProps, prevState) {

let shorty = this.embed; //`<iframe width="720" height="720" src="${this.adres}merge/mp4/hybrid${this.numbl}matter${this.numbr}.mp4" style="border:none;"></iframe>`;     
     
 document.addEventListener('copy', function(e){
  e.clipboardData.setData('text/plain', shorty);
  e.preventDefault(); // default behaviour is to copy any selected text
});     
     
//let height = window.innerHeight;     
     
  //if (this.state.wysokosc !== height ) {
  //  this.setState({wysokosc: height});
  //}
     
//<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />      
//     // style={{ transform: 'translate(-50%, -50%)', transform: 'scale( 0.5 )' }}  
// style={{ height: '100%', width: '100%' }}      
}

render() {
    
        return (
          <div className="App">

            <header>
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/animate.css@3.5.2/animate.min.css" />
            <meta name="twitter:card" content="summary_large_image" />
<meta property="og:url" content={this.merge} />
<meta property="og:image" content={this.merge} />
<meta property="og:video" content={this.merge} />            
<meta property="og:description" content="digitalcultures" />
            <meta name="viewport" content="initial-scale=1.0, maximum-scale=1.0, user-scalable=no, shrink-to-fit=no" /> 
            </header>                        

               
            
    <div className="my-specific-design" > 
            
            
            <div id="underpaint" className="pasek"

            style={{height: 8*this.state.wysokosc/9, top: this.state.wysokosc/18, borderRadius: '10px', transform: 'translate(-20px, 0)' }} ></div>        

    <div id="background"

            style={{transform: 'translate(-50%, -50%)', zIndex: '-1', display: 'none' }} >
            
    <img src={this.adres + "lefty/cutpattern.png"} alt="" />
    </div>
            

          <div id ="paint" style={{ height: '2800px' }}></div>    
          <div id="banner">         
   <div><button id="volumemark" className={"volumen " + this.state.offaudio} onClick={ (zmiana) => this.handleClick("audiom") } ></button></div>

            
<div id="horizmenu" >
    
              <div 
               style={{display: 'block', position: 'relative', float: 'right', width: '0', height: '0', paddingTop: '-20px', right: '-110px', top: '75px', marginTop: '0', zIndex: '13', borderRadius: "25px"}}>        

                    <button className="colr" disabled={this.state.dezaktywcisk} 
                    onClick={(zmiana) => this.handleClick("los")} ></button>

              </div>                 

                   <p id="matermark" style={{ position: 'absolute', display: 'block', zIndex: '22', left: '-210px', top: '-25px' }}>
<span className="mobiletitle">HYBRIDIZER<br/></span>                        
<button className={"mobile " + this.state.btncreate} 
onClick={ () => { this.modeAudio.currentTime = 0; this.modeAudio.play(); this.setState({create: "block", dwnld: "none", share: "none", about: "none", btncreate: "active", btnshare: "", btndwnld: "", btnabout: "", nohybryd: "0", dezaktywcisk: 0})} } >create</button><br/>
<button className={"mobile " + this.state.btnshare}
onClick={() => { this.modeAudio.currentTime = 0; this.modeAudio.play();  this.setState({create: "none", dwnld: "none", share: "block", about: "none", btnshare: "active", btncreate: "", btndwnld: "", btnabout: "", nohybryd: "0", dezaktywcisk: 0})} } >release</button><br/>
<button className={"mobile " + this.state.btndwnld}
onClick={() => { this.modeAudio.currentTime = 0;this.modeAudio.play(); this.setState({create: "none", dwnld: "block", share: "none", about: "none", btndwnld: "active", btncreate: "", btnshare: "", btnabout: "", nohybryd: "0", dezaktywcisk: 0})} }>preserve</button><br/>
<button className={"mobile " + this.state.btnabout}
onClick={() => { this.modeAudio.currentTime = 0; this.modeAudio.play(); this.setState({create: "none", dwnld: "none", share: "none", about: "block", btnabout: "active", btncreate: "", btndwnld: "", btnshare: "", nohybryd: "", dezaktywcisk: 1})} } >about</button>
<br/>
</p>
              <div 
                style={{display: 'block', position: 'relative', float: 'left', background: '#fff', width: '0', height: '0', paddingTop: '20px', left: '-150px', top: '20px', marginTop: '300px', zIndex: '77', borderRadius: '25px'}}> 

                    <button className="up" disabled={this.state.dezaktywcisk} 
                    onClick={(zmiana) => this.handleClick("a1") }></button>
                        <br /><br /><br /><br /><br /><br /><br />
                    <button className="dwn" disabled={this.state.dezaktywcisk} 
                    onClick={(zmiana) => this.handleClick("a2")}></button>    

              </div> 

              <div 
                style={{display: 'block', position: 'relative', float: 'right', background: '#fff', width: '0', height: '0', paddingTop: '20px', right: '-110px', top: '20px', marginTop: '300px', zIndex: '13', borderRadius: '25px'}}>

                    <button className="up" disabled={this.state.dezaktywcisk} 
                    onClick={(zmiana) => this.handleClick("b1")}></button>
                        <br /><br /><br /><br /><br /><br /><br />
                    <button className="dwn" disabled={this.state.dezaktywcisk} 
                    onClick={(zmiana) => this.handleClick("b2")}></button>

              </div> 
 </div> 

    <div id="toobackground"

            style={{transform: 'translate(-50%, -50%)', zIndex: '1' }} >  
    <img id="imgframe" src={this.adres + "lefty/layout50.png"} alt="" />
    </div>     
        <div className="maintitles"
            style={{ position: 'absolute', right: '830px', top: '-30px', zIndex: '25', fontFamily: 'GoodPro', color: '#242424', fontSize: '2.0em', lineHeight: '0.1' }}>
            HYBRIDIZER<p style={{ fontSize: '0.53em' }}><br/>release your inner beast</p></div>
        <div className="maintitles" 
                style={{ position: 'absolute', left: '820px', top: -this.state.wysokosc/25 , width: '260px', zIndex: '7', fontFamily: 'GoodPro', color: '#242424', fontSize: '1.0em' }}>
        <a href="http://digitalcultures.pl">            
                    <img  
                        style={{ verticalAlign: 'middle' }} src={this.adres + "lefty/logodc.png"} alt="watermark" /></a> <a href="http://digitalcultures.pl">digital cultures</a></div>

                        
                        
        <div id="inner-banner" style={{ }} > 
            <div style={{ left: '12px', position: 'absolute', backgroundColor: '#b01e1e', width: '100%', height: '100%', display: this.state.about }} ></div>      
        <div 
            style={{display: 'none', position: 'relative', height: '0', overflow: 'visible', top: -window.innerHeight, left: '-20px', zIndex: '0', display: 'none' }} >
            <div id="maskagora" style={{display: 'none', width: '760px', height: window.innerHeight, background: '#20262E' }}></div>
        </div>

        <div style={{ transform: 'translate(15px, 0)', opacity: this.state.nohybryd ? '1' : '0' }}>
        <div     
            style={{ display: 'block', position: 'relative', height: '0', overflow: 'visible', top: '-720px', float: 'left' }}>

          <div id="hybrydagora" style={{ display: 'inline-block' }}
            className={this.state.amateriaktiv} onAnimationEnd={() => this.setState({amateriaktiv: "moff"})} >
                <img className={"lefty alajna " + this.state.animaktiv}
                style={{ animationDuration: this.state.iteracje ? '1s' : '1s' }}
                src={this.state.urlap} alt="" 
                width="360" height="720"/>
          </div> 

          <div id="hybrydagora" style={{ display: "inline-block" }}
            className={this.state.bmateriaktiv} onAnimationEnd={() => this.setState({bmateriaktiv: "moff"})} >   
                <img  className={"righty alajna " + this.state.banimaktiv}
                style={{ animationDuration: this.state.iteracje ? '1s' : '1s'}}
                src={this.state.urlbup} alt="" 
                width="360" height="720"/>
           </div>

        </div>

                                    <div className="zabij" style={{ position: 'absolute', height: '0', overflow: 'visible', top: '26px', zIndex: '6' }}>            
                                    <div className={"pasek " + this.state.wanimaktiv} 

                                            style={{display: this.state.dezaktywcisk ? 'none' : 'block', width: '100%', height: '0', overflow: 'visible', top: '0', textAlign: 'center', margin: '0 auto'}} onAnimationEnd={() => this.setState({wanimaktiv: "off", dezaktywcisk: 0})} >
                                                <h1 className="App-title" style={{ display: this.state.clock }} >{this.wyjatek}</h1><br/>
                                                <p id="embed" className={this.state.embedinfo} style={{ color: 'white', opacity: '0' }} 
                                                onAnimationEnd={() => this.setState({embedinfo: "embedinfo"})} >embed link copied to clipboard</p>

                                    </div> 
                                    </div>         
                                    <div id="pasek" 

                                            style={{display: 'none', position: 'relative', backgroundColor: '#fff', height: '100%', width: '760px', margin: '0 auto', bottom: '15%', textAlign: 'center', zIndex: '-6', borderRadius: '10px', transform: 'translate(-20px, 0)'}} >

                                    </div>                
    <div style={{ float: 'left' }} >        
    <div id="hybrasroda" style={{ display: "inline-block" }}
        className={this.state.asrodaktiv} onAnimationEnd={() => this.setState({asrodaktiv: "hoff"})} >
                        <img className={"lefty alajna " + this.state.animaktiv}
                        style={{ animationDuration: this.state.iteracje ? '1s' : '1s'}}
                        src={this.urla} alt="" 
                        onAnimationEnd={ () => { this.setState({ animaktiv: "off", dezaktywcisk: 0}); this.iterazionEnd("a2");  } } 
                        width="360" height="720"/>
    </div>
    <div id="hybrasroda" style={{ display: "inline-block" }}
        className={this.state.bsrodaktiv} onAnimationEnd={() => this.setState({bsrodaktiv: "hoff"})} >                    
                        <img className={"righty alajna " + this.state.banimaktiv}
                        style={{ animationDuration: this.state.iteracje ? '1s' : '1s'}}
                        src={this.urlb} alt="" 
                        onAnimationEnd={ () => { this.setState({ banimaktiv: "off", dezaktywcisk: 0}); this.iterazionEnd("b1"); } } 
                        width="360" height="720"/>
    </div> 
    </div>                    

        <div   
            style={{display: 'block', position: 'relative', height: '0', overflow: 'visible', float: 'left' }}> 

            <div id="hybrydadol" style={{ display: "inline-block" }}
                className={this.state.akoteriaktiv} onAnimationEnd={() => this.setState({akoteriaktiv: "moff"})} >  
                <img className={"lefty " + this.state.animaktiv}
                style={{ animationDuration: this.state.iteracje ? '1s' : '1s'}}
                src={this.state.urladown} alt="" 
                width="360" height="720"/>
            </div>

            <div id="hybrydadol" style={{ display: "inline-block" }}
                className={this.state.bkoteriaktiv} onAnimationEnd={() => this.setState({bkoteriaktiv: "moff"})} > 
                <img className = {"righty " + this.state.banimaktiv}
                style={{ animationDuration: this.state.iteracje ? '1s' : '1s'}}
                src={this.state.urlbown} alt="" 
                width="360" height="720"/>
            </div>
        </div>                  
        </div>

                <div  className={"substrzalki " + this.state.mmmanimaktiv} style={{ display: this.state.create }} >
            <div style={{ display: this.state.clock }} >
                    <button
                    className="bold u "
                    style={{ display: this.state.dezaktywcisk ? 'none' : 'inline-block' }} 
                    disabled={this.state.dezaktywcisk} 
                    onClick={ (zmiana) => this.handleClick("a1") }></button> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    
                    <button
                    className="bold d "
                    style={{ display: this.state.dezaktywcisk ? 'none' : 'inline-block' }} 
                    disabled={this.state.dezaktywcisk} 
                    onClick={(zmiana) => this.handleClick("a2") }></button> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    
                    <button
                    className="bold l "
                    style={{ display: this.state.dezaktywcisk ? 'none' : 'inline-block' }} 
                    disabled={this.state.dezaktywcisk} 
                    onClick={(zmiana) => this.handleClick("los") }></button> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    
                    <button
                    className="bold u "
                    style={{ display: this.state.dezaktywcisk ? 'none' : 'inline-block' }} 
                    disabled={this.state.dezaktywcisk} 
                    onClick={(zmiana) => this.handleClick("b1") }></button> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;

                    <button
                    className="bold d "
                    style={{ display: this.state.dezaktywcisk ? 'none' : 'inline-block' }} 
                    disabled={this.state.dezaktywcisk} 
                    onClick={(zmiana) => this.handleClick("b2") }></button>
                </div></div>
            <div  className={"mobsubstrzalki "} >
                <span className="mobiletitle" style={{ fontFamily: 'GoodPro', fontSize: '1.5rem', position: 'relative', height: '0', top: '-3.2rem', left: '0.5rem' }} >HYBRIDIZER<br/></span>                
            <div style={{ display: this.state.clock }} >
                    &nbsp; &nbsp;<button
                    className="bold u "
                    style={{ display: this.state.dezaktywcisk ? 'none' : 'inline-block' }} 
                    disabled={this.state.dezaktywcisk} 
                    onClick={ (zmiana) => this.handleClick("a1") }></button> &nbsp; &nbsp; &nbsp; 
                    
                    <button
                    className="bold d "
                    style={{ display: this.state.dezaktywcisk ? 'none' : 'inline-block' }} 
                    disabled={this.state.dezaktywcisk} 
                    onClick={(zmiana) => this.handleClick("a2") }></button> &nbsp; &nbsp; &nbsp; 
                    
                    <button
                    className="bold l "
                    style={{ display: this.state.dezaktywcisk ? 'none' : 'inline-block' }} 
                    disabled={this.state.dezaktywcisk} 
                    onClick={(zmiana) => this.handleClick("los") }></button> &nbsp; &nbsp; &nbsp; 
                    
                    <button
                    className="bold u "
                    style={{ display: this.state.dezaktywcisk ? 'none' : 'inline-block' }} 
                    disabled={this.state.dezaktywcisk} 
                    onClick={(zmiana) => this.handleClick("b1") }></button> &nbsp; &nbsp; &nbsp; 

                    <button
                    className="bold d "
                    style={{ display: this.state.dezaktywcisk ? 'none' : 'inline-block' }} 
                    disabled={this.state.dezaktywcisk} 
                    onClick={(zmiana) => this.handleClick("b2") }></button>
                </div></div>
                    
                 <div  className={"submenu " + this.state.wanimaktiv} style={{ display: this.state.share }} >
            <div style={{ display: this.state.clock }} >
                             &nbsp; &nbsp;
                    <button
                    className="share fb "
                    style={{ display: this.state.dezaktywcisk ? 'none' : 'inline-block' }} 
                    onClick={ (zmiana) => { this.handleClick("fb"); window.open("https://www.facebook.com/sharer/sharer.php?u=" + this.adresricmerg + "720%2F" + "hybrid" + this.numbl + "matter" + this.numbr + ".gif" + "&amp;src=sdkpreparse" + "&hashtag=%23digitalcultures"); } }></button> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                            <a target="_blank" className="tumblr-share-button" href={this.richembed} data-href={this.merge} >
                    <button
                    className="share tmb "
                    style={{ display: this.state.dezaktywcisk ? 'none' : 'inline-block' }} 
                    onClick={(zmiana) => this.handleClick("tmb") }></button></a> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                              <a target="_blank" className="twitter-share-button"
                              href={"https://twitter.com/intent/tweet?text=" + this.adres + "merge/hybrid" + this.numbl + "matter" + this.numbr + ".gif" + "&hashtags=digitalcultures"}>
                    <button
                    className="share twt "
                    style={{ display: this.state.dezaktywcisk ? 'none' : 'inline-block' }} 
                    onClick={(zmiana) => this.handleClick("twt") }></button></a> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    
                    <button
                    className="share emb"
                    style={{ display: this.state.dezaktywcisk ? 'none' : 'inline-block' }} 
                    onClick={(zmiana) => this.handleClick("emb") }></button>
                 </div></div>

                <div  className={"submenu " + this.state.wanimaktiv} style={{ display: this.state.dwnld }} >
            <div style={{ display: this.state.clock }} >        
                    <div
                    className="share "
                    style={{ display: this.state.dezaktywcisk ? 'none' : 'inline-block', width: '60px' }} 
                    ></div> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                <a download="myhybrid.gif" href={this.abrest + "merge/hybrid" + this.numbl + "matter" + this.numbr + ".gif"} target="_blank"> 
                    <button
                    className="share gift "
                    style={{ display: this.state.dezaktywcisk ? 'none' : 'inline-block' }} 
                    onClick={(zmiana) => this.handleClick("gift") }></button></a> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    
                                <a download="myhybrid.mp4" href={this.abrest + "merge/mp4/ahybrid" + this.numbl + "matter" + this.numbr + ".mp4"} >
                    <button
                    className="share mpfor "
                    style={{ display: this.state.dezaktywcisk ? 'none' : 'inline-block' }} 
                    onClick={(zmiana) => this.handleClick("mpfor") }></button></a> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    
                    <div
                    className="share "
                    style={{ display: this.state.dezaktywcisk ? 'none' : 'inline-block', width: '60px' }} 
                    ></div>
                </div></div>
           <div>
                <div  className={"subabout " + this.state.wanimaktiv} style={{ display: this.state.about }} >
                 &nbsp; <br/><h2>Hybridizer</h2>

                Interactive app that lets you create and release your inner beast. Moosquirrel, zebra beetle, crocoyote or geckolephant? Whatever your hybrid nature is, revel in it!<br/><br/>
                
                Created by Kajetan Obarski (animation) and Igor Hardy (code)<br/> in cooperation with digital collections expert Łukasz Kozak.<br/><br/>
                
                The 17th century figures of animals come from Matthäus Merian's workshop and were published in the zoological works of Polish naturalist Jan Jonston. Now they have been digitised, restored, split in halves and re-animated for Hybridizer.<br/><br/>

                <a href="http://digitalcultures.pl">digitalcultures.pl</a><br/>
                #hybridmatter
                </div>
        </div>       
                <div style={{ display: 'block' }} >
                   <p id="watermark" style={{ display: 'block', color: '#fff', zIndex: '12' }}> &nbsp;
<button  className={this.state.btncreate} 
onClick={ () => { this.modeAudio.currentTime = 0; this.modeAudio.play(); this.setState({create: "block", dwnld: "none", share: "none", about: "none", btncreate: "active", btnshare: "", btndwnld: "", btnabout: "", nohybryd: "0", dezaktywcisk: 0})} } >create</button> &nbsp; &nbsp;
<button  className={this.state.btnshare}
onClick={() => { this.modeAudio.currentTime = 0; this.modeAudio.play();  this.setState({create: "none", dwnld: "none", share: "block", about: "none", btnshare: "active", btncreate: "", btndwnld: "", btnabout: "", nohybryd: "0", dezaktywcisk: 0})} } >release</button> &nbsp; &nbsp;
<button className={this.state.btndwnld}
onClick={() => { this.modeAudio.currentTime = 0;this.modeAudio.play(); this.setState({create: "none", dwnld: "block", share: "none", about: "none", btndwnld: "active", btncreate: "", btnshare: "", btnabout: "", nohybryd: "0", dezaktywcisk: 0})} }>preserve</button> &nbsp; &nbsp;
<button className={this.state.btnabout}
onClick={() => { this.modeAudio.currentTime = 0; this.modeAudio.play(); this.setState({create: "none", dwnld: "none", share: "none", about: "block", btnabout: "active", btncreate: "", btndwnld: "", btnshare: "", nohybryd: "", dezaktywcisk: 1})} } >about</button>
<br/><br/>
<span className="mobiletitle" style={{display: 'none'}}>HYBRIDIZER<br/></span>    
</p>
                </div>                    
                        <div id="waterright" className={this.state.wanimaktiv} style={{display: this.state.dezaktywcisk ? 'none' : 'none'}}>        
                             &nbsp;  &nbsp; Zaprezentuj swoją hybrydę: <br/>
                            <a className="twitter-share-button"
                              href={"https://twitter.com/intent/tweet?text=My%20Hybrid:%20" + this.adresrich + "hybrid" + this.numbl + "matter" + this.numbr + ".gif" + "&hashtags=digitalcultures"}>
                            <img style={{position: "relative", left: "10px"}} src="https://uwm.edu/studentinvolvement/wp-content/uploads/sites/260/2017/12/twitter-icon-vector.png" width={100} alt="twitter-img" /> 
                            </a>
                            <a className="tumblr-share-button" href="https://www.tumblr.com/share" data-content={this.adresrich + "hybrid" + this.numbl + "matter" + this.numbr + ".gif" + "&hashtags=digitalcultures"}></a>

                                    <div style={{display: 'inline-block'}} className="fb-share-button" 
                                data-href={this.abrest + "merge/hybrid" + this.numbl + "matter" + this.numbr + ".gif"} data-layout="button" data-size="small" data-mobile-iframe="true"><a target="_blank" href={"https://www.facebook.com/sharer/sharer.php?u=" + this.adresrich + "hybrid" + this.numbl + "matter" + this.numbr + ".gif" + "&amp;src=sdkpreparse"} className="fb-xfbml-parse-ignore"><img src="https://www.shareicon.net/download/2017/06/28/888039_logo.ico" width={50} alt="fb-img" /></a></div> &nbsp; &nbsp;

                                 <a download="mojezwierze.gif" href={this.abrest + "merge/hybrid" + this.numbl + "matter" + this.numbr + ".gif"} target="_blank">      
                                     <button className="biandwi"><strong>.gif</strong></button>
                                    <img style={{position: "relative", bottom: "5px"}} src="https://cdn.iconscout.com/public/images/icon/premium/png-512/gif-file-animation-photo-photography-image-picture-359abb9543c6bc7c-512x512.png" width={45} alt=".gif"/></a> &nbsp;

                                <a download="mojezwierze.mp4" href={this.abrest + "merge/mp4/hybrid" + this.numbl + "matter" + this.numbr + ".mp4"} >
                                    <button className="biandwi"><strong>.MP4</strong></button>
                                    <img style={{position: "relative", bottom: "-12px"}} src="https://cdn0.iconfinder.com/data/icons/video-files-icons/110/Mp4-File-512.png" width={80} alt=".mp4"/></a>      
                                        </div>

    </div>              


          </div></div>     

        <script id="tumblr-js" async src="https://assets.tumblr.com/share-button.js"></script>      
          </div>
        );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js